<ng-template #requirementEditor>
  <div class="req-editor">
    <input class="req-editor__input" type="text" [(ngModel)]="editor.name" [placeholder]="'compliance.library.checklistRequirements.requirementNamePlaceholder' | transloco">

    @if (showEditorTypeDropdown) {
      <div ngbDropdown class="req-editor__type" container="body">
        <button type="button" class="req-editor__type-toggle"
          [class.req-editor__type-toggle--placeholder]="editor.documentTypeId === null"
          ngbDropdownToggle>
          <span>{{ editorTypeLabel }}</span>
          <i class="ph ph-caret-down"></i>
        </button>
        <div ngbDropdownMenu class="req-editor__type-menu">
          @for (type of documentTypes; track type.id) {
            @if (getTypeUsedBy(type); as usedBy) {
              <button type="button" ngbDropdownItem disabled class="req-editor__type-item--linked">
                <span class="req-editor__type-item-name">{{ type.name | lookupLabel:documentTypeLabelPrefix }}</span>
                <span class="req-editor__type-item-linked-to">{{ 'compliance.library.checklistRequirements.linkedTo' | transloco: { name: usedBy } }}</span>
              </button>
            } @else {
              <button type="button" ngbDropdownItem (click)="selectEditorType(type.id)">{{ type.name | lookupLabel:documentTypeLabelPrefix }}</button>
            }
          }
          <button type="button" ngbDropdownItem (click)="selectEditorType(null)">{{ 'compliance.library.checklistRequirements.none' | transloco }}</button>
        </div>
      </div>
    }

    <label class="req-editor__critical" (click)="$event.stopPropagation()">
      <input type="checkbox" [(ngModel)]="editor.critical">
      <span>{{ 'compliance.library.checklistRequirements.critical' | transloco }}</span>
    </label>

    <button type="button" class="req-editor__save" [disabled]="isEditorSaveDisabled" (click)="saveEditorAsync()">
      @if (isSavingEditor) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        {{ 'compliance.library.checklistRequirements.save' | transloco }}
      }
    </button>
    <button type="button" class="req-editor__cancel" [disabled]="isSavingEditor" (click)="cancelEditor()">{{ 'common.cancel' | transloco }}</button>
  </div>
</ng-template>

<ng-template #requirementRow let-req let-group="group">
  @if (editingRequirementId === req.id) {
    <ng-container *ngTemplateOutlet="requirementEditor"></ng-container>
  } @else {
    <div class="req-row">
      <span class="req-row__name">{{ req.name }}</span>

      @if (getLinkedTypeName(req); as typeName) {
        <span class="type-pill">
          {{ typeName }}
          <button type="button" class="type-pill__remove" (click)="confirmUnlinkDocumentType(req)" [title]="'compliance.library.checklistRequirements.unlinkDocumentType' | transloco">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10.7946 4.23047L7.96598 7.05847L5.13798 4.23047L4.19531 5.17314L7.02331 8.00114L4.19531 10.8291L5.13798 11.7718L7.96598 8.9438L10.7946 11.7718L11.7373 10.8291L8.90931 8.00114L11.7373 5.17314L10.7946 4.23047Z" fill="#9FA1A4"/>
            </svg>
          </button>
        </span>
      }

      <span class="req-row__actions">
        <div ngbDropdown container="body" placement="bottom-end top-end" class="req-row__menu" (click)="$event.stopPropagation()">
          <button type="button" class="icon-btn" ngbDropdownToggle [title]="'compliance.library.checklistRequirements.requirementActions' | transloco">
            <i class="ph ph-dots-three-vertical"></i>
          </button>
          <div ngbDropdownMenu class="req-row-menu">
            <button type="button" ngbDropdownItem (click)="startEdit(req)">{{ 'compliance.library.checklistRequirements.edit' | transloco }}</button>
            <button type="button" ngbDropdownItem (click)="onArchiveRequirementAsync(req)">{{ 'compliance.library.checklistRequirements.archive' | transloco }}</button>
            <button type="button" ngbDropdownItem (click)="confirmDeleteRequirementAsync(req)">{{ 'compliance.library.checklistRequirements.delete' | transloco }}</button>
          </div>
        </div>
      </span>
    </div>
  }
</ng-template>

<ng-template #groupFooter let-group>
  <div class="group-footer">
    @if (addingGroupId === group.id) {
      <ng-container *ngTemplateOutlet="requirementEditor"></ng-container>
    } @else {
      <button type="button" class="add-requirement-pill" (click)="startAdd(group)">{{ 'compliance.library.checklistRequirements.addRequirement' | transloco }}</button>
    }
  </div>
</ng-template>

<div class="requirements-container">
  @if(isLoading) {
    <div class="requirements-state">
      <span class="spinner-border"></span>
    </div>
  } @else if(hasError) {
    <div class="requirements-state">
      <app-error-state></app-error-state>
    </div>
  } @else if(isEmpty) {
    <div class="requirements-state">
      <app-empty-state [message]="isArchive ? ('compliance.library.checklistRequirements.noArchivedRequirements' | transloco) : ('compliance.library.checklistRequirements.noRequirements' | transloco)"></app-empty-state>
    </div>
  } @else {
    <app-checklist-table
      [sections]="checklistSections"
      [groups]="checklistGroups"
      [rowTemplate]="isArchive ? undefined : requirementRow"
      [groupFooterTemplate]="isArchive ? undefined : groupFooter"
      (actionClicked)="onRequirementActionAsync($event)">
    </app-checklist-table>
  }
</div>
